// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h4-a";
export var fulfillmentFormRail = "_h4-9";
export var headerTitleRow = "_h4-c";
export var orderDetailsWrapper = "_h4-7";
export var orderLinkTrigger = "_h4-2";
export var paymentInformationGrid = "_h4-h";
export var paymentSummaryColumn = "_h4-i";
export var shipmentContainer = "_h4-b";
export var shipmentDetailsMainPane = "_h4-8";
export var shipmentNavigationCard = "_h4-5";
export var shipmentNavigationRail = "_h4-3";
export var shipmentNavigationRailHeader = "_h4-4";
export var shipmentSummaryFact = "_h4-e";
export var shipmentSummaryGrid = "_h4-d";
export var shipmentSummaryMetadataRow = "_h4-f";
export var shipmentSummaryTags = "_h4-g";
export var shipmentWorkspace = "_h4-0";
export var shipmentWorkspaceContent = "_h4-6";
export var shipmentWorkspaceHeader = "_h4-1";